import React from 'react'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { WorkLifeIconFinancial, WorkLifeIconIdentity } from '../atoms/icons/WorkLifeIcons'
import { CardDescription as WorkLifeCardDescription } from '../organisms/workLifeCard/WorkLifeCard'

export const newyorkfed: GetCustomerCopyFunc = () => {
  return {
    workLifeServices: [
      {
        identifiers: {
          id: 'fedProtect',
          dataTestId: 'workLife-fedProtect',
        },
        title: 'FedProtect',
        iconSvg: <WorkLifeIconIdentity size={48} />,
        paragraph: (
          <WorkLifeCardDescription
            text={
              // eslint-disable-next-line formatjs/no-literal-string-in-jsx
              'FedProtect, powered by Allstate Identity Protection, offers identity and credit monitoring, fraud remediation and restoration, and identity theft reimbursement.'
            }
          />
        ),
        bullets: [],
        CTA: 'Visit FedProtect',
        PATH: 'https://www.myaip.com/fedprotect',
      },
      {
        identifiers: {
          id: 'ayco',
          dataTestId: 'workLife-ayco',
        },
        title: 'Ayco Financial Education',
        iconSvg: <WorkLifeIconFinancial size={48} />,
        paragraph: (
          <WorkLifeCardDescription
            text={
              // eslint-disable-next-line formatjs/no-literal-string-in-jsx
              'FedProtect, powered by Allstate Identity Protection, offers identity and credit monitoring, fraud remediation and restoration, and identity theft reimbursement.\n\nAlthough Ayco coaches can’t provide investment advice, they are versed in Federal Reserve retirement benefits, and can share guidance to help you make informed decisions.'
            }
          />
        ),
        bullets: [],
        CTA: 'Visit Federal Reserve Benefits',
        PATH: 'http://federalreservebenefits.org/',
      },
    ],
  }
}
